export const normalizeDocument = (document: string = ''): string =>
  document.toUpperCase().replace(/[^0-9A-Z]/g, '');

export const normalizePrivateDocument = (document: string = ''): string =>
  normalizeDocument(document).replace(/\D/g, '');

export const normalizeLegalDocument = (document: string = ''): string =>
  normalizeDocument(document);

export const isLegalDocument = (document: string = ''): boolean => {
  const normalizedDocument = normalizeDocument(document);

  return /[A-Z]/.test(normalizedDocument) || normalizedDocument.length > 11;
};

export const normalizeDocumentByType = (document: string = ''): string =>
  isLegalDocument(document)
    ? normalizeLegalDocument(document)
    : normalizePrivateDocument(document);
